import impulse from '../assets/impulse.png';
import impulseConditional from '../assets/impulseConditional.png';
import chain from '../assets/chain.png';
import chainConditional from '../assets/chainConditional.png';
import repeat from '../assets/repeat.png';
import repeatConditional from '../assets/repeatConditional.png';

const blockImages = {
  impulse: impulse,
  impulseConditional: impulseConditional,
  chain: chain,
  chainConditional: chainConditional,
  repeat: repeat,
  repeatConditional: repeatConditional
};

export default blockImages;